import { useContext } from 'react';

import { AdmindashboardContext } from '../AdmindashboardContext';

const useAdminDashboardContext = () => useContext(AdmindashboardContext);

export default useAdminDashboardContext;
